import { Slice } from '@lglp/prismic-client';

import { RichTextFormat } from '../../../schema/prismic/fields/text';
import { Link } from '../../link';

export enum LaPosteEn4SliceType {
  HEADER = 'header',
  PROOF_CATEGORY = 'proof_category',
  DISCLAIMER = 'disclaimer',
  FOOTNOTES = 'footnotes',
}

export type HeaderSlice = Slice & {
  image: any;
  description: RichTextFormat[];
  ctaLabel: string;
  ctaLink: Link;
};

export type ProofCategorySlice = Slice & {
  title: string;
  theme: string;
  items: {
    icon: string;
    title: string;
    description: RichTextFormat[];
    ctaLabel?: string;
    ctaLink?: Link;
  }[];
};

export type DisclaimerSlice = Slice & {
  description: RichTextFormat[];
};

export type FootnotesSlice = Slice & {
  notes: {
    reference: string;
    description: string;
  }[];
};
